import { BaseDto } from './base.dto';

export class CountryDto extends BaseDto {
  name: string;
  code: string;
  startDate?: Date;
  endDate?: Date;
  callingCode?: string;
  requireVisa?: boolean;
  
}
